import React, { useContext, useState, useEffect } from "react";

import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import {
  SliderRail,
  KeyboardHandle,
  Track,
  Tick,
} from "../../components/component/SliderComponent";

import { DesignProgramContext } from "../CustomHooks/ContextApi";
import isTouchDevice from "../SE-Component/Tooltip";
import ErrorBoundary from '../../utils/ErrorBoundary'
import Tooltip from "../../utils/Tooltip";
import { generateRandom } from "../../utils/randomGenerator";
import { useAtom } from "jotai";
import { projectAtomList } from "../../atoms";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
const sliderStyle = {
  position: "relative",
  width: "100%",
  // Horizontal default height is driven by internal elements.
};


const LoadShedding = () => {
  const {
    loadsDisplay,
    loadShedding,
    loads,
    loadList,
    reconnectionTimers,
    defaultsMinMax,
    values,
    domain,
    batteryDetails,
    gensetDetails,
    BESS,
    powerReservePercentageBESS,
    genset,
    powerReservePercentageGenset,
    loadSheddingChangeHandler,
    onDrag,
    onDrop,
    onDragFrom,
    onDragOver,
    configuredStatusModified,
    handleChange,
    onUpdate,
    onChange,
    handleChangeBESS,
    handleChangePowerReservePercentage,
    handleChangeGenset,
    gridTiedLoadsSheddable,
    siteType,
    limitImport,
    gridSettings
  } = useContext(DesignProgramContext);
  const projectTypeValue = useProjectTypeValue();
  const isGridSiteWithImportLimitationTrue = limitImport && (siteType === "GRID_CONNECTED" && (["MGaaS ANSI", "MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue)));
  const loadManagementImportAndExport = (siteType === "ISLANDABLE" && (["MGaaS ANSI", "MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue)));
  const [currentProject,] = useAtom(projectAtomList)
  const [verticalView, setVerticalView] = useState(false);
  const [showCustomHandle, setShowCustomHandle] = useState(false);
  // Styles for vertical orientation (container + root)
  const verticalSliderContainerStyle = () => {
    return verticalView ? {
      height: 300,
      width: 250, // widened to allow labels on the right
      position: "relative",
      margin: "0 auto",
      display: 'flex',
      justifyContent: 'center',
    } : {
      height: 30,
      width: "100%",
    }
  };

  const verticalRootStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
  };
  // const {
  //   project: { projectInfo: { gridSettings: { mode = "" } = {} } = {} } = {},
  // } = currentProject;
  const mode = currentProject?.project?.projectInfo?.gridSettings?.mode ?? "";
  const reconnectionTimerChangeHandler = e => {
    handleChange(e);
    configuredStatusModified("lsConfiguredStatus");
  };

  const BessChangeHandler = e => {
    handleChangeBESS(e);
    configuredStatusModified("lsConfiguredStatus");
  };

  const gensetChangeHandler = e => {
    handleChangeGenset(e);
    configuredStatusModified("lsConfiguredStatus");
  };

  const PowerChangeHandler = e => {
    handleChangePowerReservePercentage(e);
    configuredStatusModified("lsConfiguredStatus");
  };

  const showBess = () => {
    if (mode === "FUEL_ERASER") {
      return true;
    }

    return mode === "NO_FUEL";
  };

  const showGenset = () => {
    if (mode === "FUEL_ERASER") {
      return true;
    }
    return mode === "FUEL_SAVER";
  };

  // After initial mount, display the custom slider handle overlay
  useEffect(() => {
    // Delay to ensure slider renders first (optional minimal timeout)
    const t = setTimeout(() => setShowCustomHandle(true), 0);
    return () => clearTimeout(t);
  }, []);


  const loadSheddingStatus = () => {
    const resources = currentProject?.resources?.resources;
    let loadManagementTabStatus = false;
    resources?.forEach((resourcesData) => {
      if (
        parseInt(resourcesData.attributes[0].motorized.attributeValue) === 1
      ) {
        loadManagementTabStatus = true;
      }
    })
    if (isGridSiteWithImportLimitationTrue) {
      return loadManagementTabStatus && isGridSiteWithImportLimitationTrue;
    }
    if (loadManagementImportAndExport) {
      return loadManagementTabStatus && loadManagementImportAndExport;
    }
  }
  return (
    <ErrorBoundary>
      <>
        {(loadsDisplay || loadSheddingStatus()) && (
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
            {/* During grid tied opration */}
            {(isGridSiteWithImportLimitationTrue || (loadManagementImportAndExport && gridSettings.exportOptimization && limitImport)) &&
              <div className="row d-flex mt-3 align-items-center">
                <div className="col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-2 bold">
                  Activate Load Shedding / Reconnection During Grid Tied Operation
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="islandOperation1"
                      name="loadSheddingGridtiedStatus"
                      className="custom-control-input islandableRadio asCompatible"
                      value="Y"
                      checked={loadShedding.loadSheddingGridtiedStatus === "Y"}
                      onChange={loadSheddingChangeHandler}
                    />
                    <label
                      className="custom-control-label line-height-25px"
                      htmlFor="islandOperation1"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="islandOperation2"
                      name="loadSheddingGridtiedStatus"
                      className="custom-control-input islandableRadio asCompatible"
                      value="N"
                      checked={loadShedding.loadSheddingGridtiedStatus === "N"}
                      onChange={loadSheddingChangeHandler}
                    />
                    <label
                      className="custom-control-label line-height-25px"
                      htmlFor="islandOperation2"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
              }
            {/* During islandable operation */}
            {loadManagementImportAndExport && <div className="row d-flex mt-3 align-items-center">
              <div className="col-sm-5 col-md-5 col-lg-4 col-xl-5 mb-2 bold">
                Activate Load Shedding / Reconnection During Island Operation
              </div>
              <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="customRadioL1"
                    name="loadSheddingStatus"
                    className="custom-control-input islandableRadio asCompatible"
                    value="Y"
                    checked={loadShedding.loadSheddingStatus === "Y"}
                    onChange={loadSheddingChangeHandler}
                  />
                  <label
                    className="custom-control-label line-height-25px"
                    htmlFor="customRadioL1"
                  >
                    Yes
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="customRadioL2"
                    name="loadSheddingStatus"
                    className="custom-control-input islandableRadio asCompatible"
                    value="N"
                    checked={loadShedding.loadSheddingStatus === "N"}
                    onChange={loadSheddingChangeHandler}
                  />
                  <label
                    className="custom-control-label line-height-25px"
                    htmlFor="customRadioL2"
                  >
                    No
                  </label>
                </div>
              </div>
            </div>}



          </div>
        )}

        {loadShedding.loadShedding === true 
        ||loadShedding.loadSheddingActivatedGridTied === true?
          (    (loadShedding.loadSheddingStatus === "Y" && loadShedding.loadSheddingGridtiedStatus === "Y")
            || (loadShedding.loadSheddingStatus === "N" && loadShedding.loadSheddingGridtiedStatus === "Y")
            || (loadShedding.loadSheddingStatus === "Y" && loadShedding.loadSheddingGridtiedStatus === "N")
            || (loadShedding.loadSheddingStatus === "N" && loadShedding.loadSheddingGridtiedStatus === "Y")
          )
          && (
            <div className="col-md-12 mt-1">
              {loadsDisplay === true && (siteType === "ISLANDABLE" || loadShedding.loadSheddingGridtiedStatus === "Y") && (
                <div>
                  <div className="row">
                    <div className="col-md-12 mt-1 ">
                      <span>
                        Drag & drop your load accordingly with their sheddable
                        prioritization{" "}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <div
                        className="se-grey-background-loads  loads-min-height"
                        onDrop={(event) => onDrop(event, "loads")}
                        onDragOver={(event) => onDragOver(event)}
                      >
                        {loads?.map((loadData) =>
                          parseInt(
                            loadData.attributes[0].motorized.attributeValue
                          ) === 1 ? (
                            <span
                              id={loadData.resourceId}
                              key={loadData.resourceId}
                              className="se-chip align-middle "
                              draggable
                              onDrag={(e) => onDrag(e, loadData)}
                            >
                              <se-icon size="small" color="primary">
                                {loadData.resourceType === "Load"
                                  ? "electrical_plug"
                                  : "electrical_vehicle1"}
                              </se-icon>
                              <span className="align-top line-height-25">
                                {loadData.resourceName}
                              </span>
                            </span>
                          ) : (
                            ""
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  {loadShedding.loadSheddingStatus === "Y" && loadShedding.loadSheddingGridtiedStatus === "Y" &&
                    <div className="row">
                      <div className="col-md-12 mt-1 ">
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm mt-2">
                            <thead className="text-center">
                              {siteType !== "GRID_CONNECTED" && <tr>
                                <th width="10%" className="text-center"></th>

                                <th width="50%" colSpan={2}>Loads</th>
                                <th width="30%"></th>
                              </tr>}
                              <tr>
                                <th width="10%" className="text-center">Priority</th>
                                {siteType !== "GRID_CONNECTED" ? <>
                                  <th width="25%">Grid Tied</th>
                                  <th width="25%">Islandable</th>
                                </>
                                  :
                                  <th width="50%" >Loads</th>
                                }
                                <th width="30%">Group</th>
                              </tr>
                            </thead>
                            <tbody>
                              {isGridSiteWithImportLimitationTrue === false &&
                                <tr>
                                  <td className="text-center">
                                    {Array(loadList.emergencyList.length)
                                      .fill(null)
                                      .map((data, index) => (
                                        <div
                                          className="col-md-12 min-height-35px  emergency bold"
                                          key={generateRandom() * 1000}
                                        >
                                          {index + 1}
                                        </div>
                                      ))}
                                  </td>
                                  <td className="text-center">NA</td>
                                  <td>
                                    <div
                                      className="col-md-12 loads-min-height"
                                      onDrop={(e) => onDrop(e, "emergency", "islandable")}
                                      onDragOver={(event) => onDragOver(event)}
                                    >
                                      <div className="row">
                                        {loadList.emergencyList.map(
                                          (emergencyData) => (
                                            <div
                                              className="col-md-12"
                                              key={emergencyData.resourceId}
                                            >
                                              <span
                                                id={emergencyData.resourceId}
                                                className="se-chip align-middle "
                                                draggable
                                                onDrag={(event) =>
                                                  onDragFrom(
                                                    event,
                                                    emergencyData,
                                                    "emergency"
                                                  )
                                                }
                                              >
                                                <se-icon size="small" color="primary">
                                                  {emergencyData.resourceType ===
                                                    "Load"
                                                    ? "electrical_plug"
                                                    : "electrical_vehicle1"}
                                                </se-icon>
                                                <span className="align-top line-height-25">
                                                  {emergencyData.resourceName}
                                                </span>
                                              </span>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </td>

                                  <td className="align-middle">
                                    <div className="align-middle emergency d-flex">
                                      <div>
                                        <se-icon size="small">
                                          notification_critical
                                        </se-icon>
                                      </div>
                                      <div className="pt-1 pl-2 pr-2">Emergency</div>
                                    </div>
                                  </td>
                                </tr>}

                              {(isGridSiteWithImportLimitationTrue === false) && <tr>
                                <td className="text-center">
                                  {Array(loadList.essentialList.length)
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px essential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length + index + 1}
                                      </div>
                                    ))}
                                </td>
                                <td className="text-center">NA</td>
                                <td>
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) => onDrop(event, "essential", "islandable")}
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.essentialList.map(
                                        (essentialData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={essentialData.resourceId}
                                          >
                                            <span
                                              id={essentialData.resourceId}
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  essentialData,
                                                  "essential"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {essentialData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {essentialData.resourceName}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle essential d-flex">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2"> Essential</div>
                                  </div>
                                </td>
                              </tr>}

                              {(isGridSiteWithImportLimitationTrue === true || loadManagementImportAndExport) && <tr>
                                <td className="text-center">
                                  {Array(loadList.nonEssentialList.length)
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td colSpan={siteType === "GRID_CONNECTED" ? 1 : 2}>
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "nonEssential", "gridAndIsland")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.nonEssentialList.map(
                                        (nonEssentialData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={nonEssentialData.resourceId}
                                          >
                                            <span
                                              id={nonEssentialData.resourceId}
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  nonEssentialData,
                                                  "nonEssential"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {nonEssentialData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {nonEssentialData.resourceName}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2">
                                      {" "}
                                      Non Essential
                                    </div>
                                  </div>
                                </td>
                              </tr>}
                              {isGridSiteWithImportLimitationTrue === false && <tr>
                                <td className="text-center">
                                  {Array(
                                    loadList?.gridTiedNotAllowIslandingList?.length
                                  )
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >

                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          loadList.nonEssentialList.length +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td>
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "gridTiedNotAllowIslanding", "grid")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.gridTiedNotAllowIslandingList.map(
                                        (gridTiedNotAllowIslandingData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={
                                              gridTiedNotAllowIslandingData.resourceId
                                            }
                                          >
                                            <span
                                              id={
                                                gridTiedNotAllowIslandingData.resourceId
                                              }
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  gridTiedNotAllowIslandingData,
                                                  "gridTiedNotAllowIslanding"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {gridTiedNotAllowIslandingData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {
                                                  gridTiedNotAllowIslandingData.resourceName
                                                }
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">NA</td>
                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex se-block-enabled">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2">
                                      Grid-Tied Only
                                    </div>
                                    <div className="se-block-enabled  ">
                                      <se-tooltip
                                        action={isTouchDevice() ? "click" : "hover"}
                                        position={"top"}
                                      >
                                        <se-icon
                                          option="raised"
                                          slot="tooltip"
                                          color={"secondary"}
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content
                                          style={{
                                            textAlign: "left",
                                            padding: "8px",
                                          }}
                                        >
                                          {"Grid Tied only loads are shed in Grid Tied mode, only if Non- Essential load shedding is not enough to manage the import limit threshold"}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>

                                  <span className="pl-4 ml-2">
                                    Failure mode - Do Not Allow Islanding{" "}
                                  </span>
                                </td>
                              </tr>}
                              {isGridSiteWithImportLimitationTrue === false && <tr>
                                <td className="text-center">
                                  {Array(
                                    loadList?.gridTiedAllowIslandingList?.length
                                  )
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          loadList.nonEssentialList.length +
                                          loadList.gridTiedNotAllowIslandingList
                                            .length
                                          +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td >
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "gridTiedAllowIslanding", "grid")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.gridTiedAllowIslandingList.map(
                                        (gridTiedAllowIslandingData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={
                                              gridTiedAllowIslandingData.resourceId
                                            }
                                          >
                                            <span
                                              id={
                                                gridTiedAllowIslandingData.resourceId
                                              }
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  gridTiedAllowIslandingData,
                                                  "gridTiedAllowIslanding"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {gridTiedAllowIslandingData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {
                                                  gridTiedAllowIslandingData.resourceName
                                                }
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">NA</td>
                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex se-block-enabled">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="se-block-enabled pt-1 pl-2 pr-2">
                                      Grid-Tied Only
                                    </div>
                                    <div>
                                      {" "}
                                      <se-tooltip
                                        action={isTouchDevice() ? "click" : "hover"}
                                        position={"top"}
                                      >
                                        <se-icon
                                          option="raised"
                                          slot="tooltip"
                                          color={"secondary"}
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content
                                          style={{
                                            textAlign: "left",
                                            padding: "8px",
                                          }}
                                        >
                                          {"Islanding sequence of operation will be executed even if Grid Tied Only load breaker fails to open."}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>

                                  <span className="pl-4 ml-2">
                                    Failure mode - Allow Islanding{" "}
                                  </span>
                                </td>
                              </tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {false && (loadList?.gridTiedNotAllowIslandingList.length > 0 || loadList?.gridTiedAllowIslandingList.length > 0) && (
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                          <div className="row mt-2">
                            <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 mb-2 bold d-flex align-items-center">
                              <div>{"Is Load Shedding required for Grid-Tied Only loads on utility power outage?"}</div>
                              <div>
                                <se-tooltip
                                  action={isTouchDevice() ? "click" : "hover"}
                                  position={"top"}
                                >
                                  <se-icon
                                    option="raised"
                                    slot="tooltip"
                                    color={"secondary"}
                                  >
                                    information_circle
                                  </se-icon>
                                  <se-tooltip-content>
                                    {"Grid Tied Only loads will be disconnec- ted on utility power outage. They will be connected back only after utility reconnection."}
                                  </se-tooltip-content>
                                </se-tooltip>
                              </div>
                            </div>
                            <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 mb-2 ">
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="loadSheddable1"
                                  name="loadSheddable"
                                  className="custom-control-input islandableRadio asCompatible"
                                  value="0"
                                  checked={gridTiedLoadsSheddable === "0"}
                                  onChange={loadSheddingChangeHandler}
                                />
                                <label
                                  className="custom-control-label line-height-25px"
                                  htmlFor="loadSheddable1"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="loadSheddable2"
                                  name="loadSheddable"
                                  className="custom-control-input islandableRadio asCompatible"
                                  value="1"
                                  checked={gridTiedLoadsSheddable === "1"}
                                  onChange={loadSheddingChangeHandler}
                                />
                                <label
                                  className="custom-control-label line-height-25px"
                                  htmlFor="loadSheddable2"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last shedding (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnectionTimer"
                              placeholder="Delay before reconnecting a load after last shedding(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnectionTimer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnectionTimer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last
                              shedding(s) is required.
                            </div>

                            {reconnectionTimers.reconnectionTimer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnectionTimer) <
                                defaultsMinMax.delayReconnectingMin ||
                                parseInt(reconnectionTimers.reconnectionTimer) >
                                defaultsMinMax.delayReconnectingMax) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last
                                shedding(s) should be{" "}
                                {defaultsMinMax.delayReconnectingMin} -{" "}
                                {defaultsMinMax.delayReconnectingMax} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last load
                            reconnection (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnection2Timer"
                              placeholder="Delay before reconnecting a load after last load reconnection(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnection2Timer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnection2Timer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last load
                              reconnection(s) is required.
                            </div>
                            {reconnectionTimers.reconnection2Timer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnection2Timer) <
                                defaultsMinMax.delayReconnecting2Min ||
                                parseInt(reconnectionTimers.reconnection2Timer) >
                                defaultsMinMax.delayReconnecting2Max) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last load
                                reconnection(s) should be{" "}
                                {defaultsMinMax.delayReconnecting2Min} -{" "}
                                {defaultsMinMax.delayReconnecting2Max} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>}
                  {loadShedding.loadSheddingStatus === "Y" && loadShedding.loadSheddingGridtiedStatus === "N" &&
                    <div className="row">
                      <div className="col-md-12 mt-1 ">
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm mt-2">
                            <thead className="text-center">
                              <tr>
                                <th width="10%" className="text-center">Priority</th>
                                <th width="50%" >Loads</th>
                                <th width="30%">Group</th>
                              </tr>
                            </thead>
                            <tbody>
                              {isGridSiteWithImportLimitationTrue === false &&
                                <tr>
                                  <td className="text-center">
                                    {Array(loadList.emergencyList.length)
                                      .fill(null)
                                      .map((data, index) => (
                                        <div
                                          className="col-md-12 min-height-35px  emergency bold"
                                          key={generateRandom() * 1000}
                                        >
                                          {index + 1}
                                        </div>
                                      ))}
                                  </td>
                                  <td>
                                    <div
                                      className="col-md-12 loads-min-height"
                                      onDrop={(e) => onDrop(e, "emergency")}
                                      onDragOver={(event) => onDragOver(event)}
                                    >
                                      <div className="row">
                                        {loadList.emergencyList.map(
                                          (emergencyData) => (
                                            <div
                                              className="col-md-12"
                                              key={emergencyData.resourceId}
                                            >
                                              <span
                                                id={emergencyData.resourceId}
                                                className="se-chip align-middle "
                                                draggable
                                                onDrag={(event) =>
                                                  onDragFrom(
                                                    event,
                                                    emergencyData,
                                                    "emergency"
                                                  )
                                                }
                                              >
                                                <se-icon size="small" color="primary">
                                                  {emergencyData.resourceType ===
                                                    "Load"
                                                    ? "electrical_plug"
                                                    : "electrical_vehicle1"}
                                                </se-icon>
                                                <span className="align-top line-height-25">
                                                  {emergencyData.resourceName}
                                                </span>
                                              </span>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </td>

                                  <td className="align-middle">
                                    <div className="align-middle emergency d-flex">
                                      <div>
                                        <se-icon size="small">
                                          notification_critical
                                        </se-icon>
                                      </div>
                                      <div className="pt-1 pl-2 pr-2">Emergency</div>
                                    </div>
                                  </td>
                                </tr>}

                              {(isGridSiteWithImportLimitationTrue === false) && <tr>
                                <td className="text-center">
                                  {Array(loadList.essentialList.length)
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px essential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length + index + 1}
                                      </div>
                                    ))}
                                </td>

                                <td>
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) => onDrop(event, "essential")}
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.essentialList.map(
                                        (essentialData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={essentialData.resourceId}
                                          >
                                            <span
                                              id={essentialData.resourceId}
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  essentialData,
                                                  "essential"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {essentialData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {essentialData.resourceName}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle essential d-flex">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2"> Essential</div>
                                  </div>
                                </td>
                              </tr>}

                              {(isGridSiteWithImportLimitationTrue === true || loadManagementImportAndExport) && <tr>
                                <td className="text-center">
                                  {Array(loadList.nonEssentialList.length)
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td >
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "nonEssential")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.nonEssentialList.map(
                                        (nonEssentialData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={nonEssentialData.resourceId}
                                          >
                                            <span
                                              id={nonEssentialData.resourceId}
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  nonEssentialData,
                                                  "nonEssential"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {nonEssentialData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {nonEssentialData.resourceName}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2">
                                      {" "}
                                      Non Essential
                                    </div>
                                  </div>
                                </td>
                              </tr>}
                              {isGridSiteWithImportLimitationTrue === false && <tr>
                                <td className="text-center">
                                  {Array(
                                    loadList?.gridTiedNotAllowIslandingList?.length
                                  )
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >

                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          loadList.nonEssentialList.length +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td>
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "gridTiedNotAllowIslanding", "grid")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.gridTiedNotAllowIslandingList.map(
                                        (gridTiedNotAllowIslandingData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={
                                              gridTiedNotAllowIslandingData.resourceId
                                            }
                                          >
                                            <span
                                              id={
                                                gridTiedNotAllowIslandingData.resourceId
                                              }
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  gridTiedNotAllowIslandingData,
                                                  "gridTiedNotAllowIslanding"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {gridTiedNotAllowIslandingData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {
                                                  gridTiedNotAllowIslandingData.resourceName
                                                }
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex se-block-enabled">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2">
                                      Grid-Tied Only
                                    </div>
                                    <div className="se-block-enabled  ">
                                      <se-tooltip
                                        action={isTouchDevice() ? "click" : "hover"}
                                        position={"top"}
                                      >
                                        <se-icon
                                          option="raised"
                                          slot="tooltip"
                                          color={"secondary"}
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content
                                          style={{
                                            textAlign: "left",
                                            padding: "8px",
                                          }}
                                        >
                                          {"Grid Tied only loads are shed in Grid Tied mode, only if Non- Essential load shedding is not enough to manage the import limit threshold"}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>

                                  <span className="pl-4 ml-2">
                                    Failure mode - Do Not Allow Islanding{" "}
                                  </span>
                                </td>
                              </tr>}
                              {isGridSiteWithImportLimitationTrue === false && <tr>
                                <td className="text-center">
                                  {Array(
                                    loadList?.gridTiedAllowIslandingList?.length
                                  )
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          loadList.nonEssentialList.length +
                                          loadList.gridTiedNotAllowIslandingList
                                            .length
                                          +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td >
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "gridTiedAllowIslanding", "grid")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.gridTiedAllowIslandingList.map(
                                        (gridTiedAllowIslandingData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={
                                              gridTiedAllowIslandingData.resourceId
                                            }
                                          >
                                            <span
                                              id={
                                                gridTiedAllowIslandingData.resourceId
                                              }
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  gridTiedAllowIslandingData,
                                                  "gridTiedAllowIslanding"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {gridTiedAllowIslandingData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {
                                                  gridTiedAllowIslandingData.resourceName
                                                }
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex se-block-enabled">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="se-block-enabled pt-1 pl-2 pr-2">
                                      Grid-Tied Only
                                    </div>
                                    <div>
                                      {" "}
                                      <se-tooltip
                                        action={isTouchDevice() ? "click" : "hover"}
                                        position={"top"}
                                      >
                                        <se-icon
                                          option="raised"
                                          slot="tooltip"
                                          color={"secondary"}
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content
                                          style={{
                                            textAlign: "left",
                                            padding: "8px",
                                          }}
                                        >
                                          {"Grid Tied only loads are shed in Grid Tied mode, only if Non- Essential load shedding is not enough to manage the import limit threshold"}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>

                                  <span className="pl-4 ml-2">
                                    Failure mode - Allow Islanding{" "}
                                  </span>
                                </td>
                              </tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last shedding (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnectionTimer"
                              placeholder="Delay before reconnecting a load after last shedding(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnectionTimer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnectionTimer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last
                              shedding(s) is required.
                            </div>

                            {reconnectionTimers.reconnectionTimer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnectionTimer) <
                                defaultsMinMax.delayReconnectingMin ||
                                parseInt(reconnectionTimers.reconnectionTimer) >
                                defaultsMinMax.delayReconnectingMax) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last
                                shedding(s) should be{" "}
                                {defaultsMinMax.delayReconnectingMin} -{" "}
                                {defaultsMinMax.delayReconnectingMax} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last load
                            reconnection (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnection2Timer"
                              placeholder="Delay before reconnecting a load after last load reconnection(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnection2Timer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnection2Timer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last load
                              reconnection(s) is required.
                            </div>
                            {reconnectionTimers.reconnection2Timer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnection2Timer) <
                                defaultsMinMax.delayReconnecting2Min ||
                                parseInt(reconnectionTimers.reconnection2Timer) >
                                defaultsMinMax.delayReconnecting2Max) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last load
                                reconnection(s) should be{" "}
                                {defaultsMinMax.delayReconnecting2Min} -{" "}
                                {defaultsMinMax.delayReconnecting2Max} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>}
                  {( siteType === "GRID_CONNECTED" && (isGridSiteWithImportLimitationTrue && loadShedding.loadSheddingGridtiedStatus === "Y")

                   ||(loadShedding.loadSheddingStatus === "N" && loadShedding.loadSheddingGridtiedStatus === "Y")) &&
                    <div className="row">
                      <div className="col-md-12 mt-1 ">
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm mt-2">
                            <thead className="text-center">
                              <tr>
                                <th width="10%" className="text-center">Priority</th>
                                <th width="50%" >Loads</th>
                                <th width="30%">Group</th>
                              </tr>
                            </thead>
                            <tbody>


                              <tr>
                                <td className="text-center">
                                  {Array(loadList.nonEssentialList.length)
                                    .fill(null)
                                    .map((data, index) => (
                                      <div
                                        className="col-md-12 min-height-35px nonEssential bold"
                                        key={generateRandom() * 1000}
                                      >
                                        {loadList.emergencyList.length +
                                          loadList.essentialList.length +
                                          index +
                                          1}
                                      </div>
                                    ))}
                                </td>
                                <td >
                                  <div
                                    className="col-md-12 loads-min-height"
                                    onDrop={(event) =>
                                      onDrop(event, "nonEssential")
                                    }
                                    onDragOver={(event) => onDragOver(event)}
                                  >
                                    <div className="row">
                                      {loadList.nonEssentialList.map(
                                        (nonEssentialData, index) => (
                                          <div
                                            className="col-md-12"
                                            key={nonEssentialData.resourceId}
                                          >
                                            <span
                                              id={nonEssentialData.resourceId}
                                              className="se-chip align-middle "
                                              draggable
                                              onDrag={(event) =>
                                                onDragFrom(
                                                  event,
                                                  nonEssentialData,
                                                  "nonEssential"
                                                )
                                              }
                                            >
                                              <se-icon size="small" color="primary">
                                                {nonEssentialData.resourceType ===
                                                  "Load"
                                                  ? "electrical_plug"
                                                  : "electrical_vehicle1"}
                                              </se-icon>
                                              <span className="align-top line-height-25">
                                                {nonEssentialData.resourceName}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td className="align-middle">
                                  <div className="align-middle nonEssential d-flex">
                                    <div>
                                      {" "}
                                      <se-icon size="small">
                                        notification_critical
                                      </se-icon>
                                    </div>
                                    <div className="pt-1 pl-2 pr-2">
                                      {" "}
                                      Non Essential
                                    </div>
                                  </div>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last shedding (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnectionTimer"
                              placeholder="Delay before reconnecting a load after last shedding(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnectionTimer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnectionTimer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last
                              shedding(s) is required.
                            </div>

                            {reconnectionTimers.reconnectionTimer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnectionTimer) <
                                defaultsMinMax.delayReconnectingMin ||
                                parseInt(reconnectionTimers.reconnectionTimer) >
                                defaultsMinMax.delayReconnectingMax) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last
                                shedding(s) should be{" "}
                                {defaultsMinMax.delayReconnectingMin} -{" "}
                                {defaultsMinMax.delayReconnectingMax} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail11"
                            className="col-sm-7 col-form-label"
                          >
                            Delay before reconnecting a load after last load
                            reconnection (s)
                            <span className="se-mandatory">*</span>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              autoComplete="none"
                              className="form-control form-control-md"
                              name="reconnection2Timer"
                              placeholder="Delay before reconnecting a load after last load reconnection(s)"
                              maxLength="10"
                              value={reconnectionTimers.reconnection2Timer}
                              onChange={reconnectionTimerChangeHandler}
                            />
                            <div
                              className="invalid-feedback-custom"
                              style={
                                reconnectionTimers.reconnection2Timer.toString() !==
                                  ""
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              Delay before reconnecting a load after last load
                              reconnection(s) is required.
                            </div>
                            {reconnectionTimers.reconnection2Timer.toString() !==
                              "" &&
                              (parseInt(reconnectionTimers.reconnection2Timer) <
                                defaultsMinMax.delayReconnecting2Min ||
                                parseInt(reconnectionTimers.reconnection2Timer) >
                                defaultsMinMax.delayReconnecting2Max) ? (
                              <div className="invalid-feedback-custom">
                                Delay before reconnecting a load after last load
                                reconnection(s) should be{" "}
                                {defaultsMinMax.delayReconnecting2Min} -{" "}
                                {defaultsMinMax.delayReconnecting2Max} s.
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>}
                 

                </div>
              )}




              {batteryDetails.batteryBuffering && showBess() && (
                <div className="row">
                  <div className="col-md-12 mt-2">
                    <div className="row">
                      <div className="col-md-6">
                        <span className="se-font-14px-bold ">
                          BESS Load Management
                        </span>
                        <Tooltip
                          position="top"
                          iconColor="secondary"
                          information="Load shedding applies to BESS state of charge when BESS is connected without genset. Groups of loads are shed based on State of charge thresholds. In addition, the controls ensure there is enough power reserve in the system. 
                    When BESS is overloaded, the control system starts shedding the load by priorities."
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 pl-3 mt-2">
                        <span>
                          "Load shedding based on BESS State of Charge and Power
                          reserve"
                        </span>
                      </div>
                    </div>

                    <div className="row mb-4 mt-4">
                      <div className="col-md-12 pr-3 mt-3 mb-4">
                        {values !== "" ? (
                          <div style={verticalSliderContainerStyle()}>
                            <Slider
                              mode={2}
                              step={1}
                              domain={domain}
                              rootStyle={verticalRootStyle}
                              onUpdate={onUpdate}
                              onChange={onChange}
                              values={values}
                              vertical={verticalView}
                            >
                              <Rail>
                                {({ getRailProps }) => (
                                  <SliderRail getRailProps={getRailProps} vertical={verticalView} />
                                )}
                              </Rail>
                              <Handles>
                                {({ handles, getHandleProps }) => (
                                  <div className="slider-handles">
                                    {showCustomHandle && (
                                      <div
                                        role="slider"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        aria-valuenow="52"
                                        style={{
                                          left: `${BESS?.SoC_fallback}%`,
                                          position: "absolute",
                                          transform: "translate(-50%, -50%)",
                                          zIndex: 2,
                                          backgroundColor: "#6600cc",
                                          borderRadius: "100%",
                                          width: 16,
                                          height: 16,
                                          cursor: "pointer"
                                        }}
                                      >
                                        <div
                                          style={{
                                            borderLeft: "1px solid #6600cc",
                                            height: 40,
                                            marginTop: -12,
                                            marginLeft: 8,
                                            zIndex: 1
                                          }}
                                        ></div>
                                        <div
                                          style={{
                                            position: "absolute",
                                            fontSize: 10,
                                            marginTop: currentProject?.isEnergyReserveSelectd ? -90 : -68,
                                            textAlign: "left",
                                            left: `${BESS?.SoC_fallback}%`,
                                            width: 90
                                          }}
                                        >
                                          <span title="SoC Fallback">SoC Fallback</span>
                                        </div>
                                        <div
                                          style={{
                                            position: "absolute",
                                            fontSize: 10,
                                            marginTop: 10,
                                            textAlign: "left",
                                            // left: `${BESS?.SoC_fallback}%`,
                                            width: 90
                                          }}
                                        >
                                          {BESS?.SoC_fallback}%
                                        </div>
                                      </div>
                                    )}
                                    {handles.map((handle, index) =>
                                      currentProject?.isEnergyReserveSelectd ? (index === 0 || index === 1 || index === 5) ?
                                        (<KeyboardHandle
                                          key={handle.id}
                                          handle={handle}
                                          domain={domain}
                                          getHandleProps={function () { }}
                                          values={values}
                                          index={index}
                                          vertical={verticalView}
                                          isEnergyReserveSelectd={currentProject?.isEnergyReserveSelectd}
                                        />
                                        ) : (
                                          <KeyboardHandle
                                            key={handle.id}
                                            handle={handle}
                                            domain={domain}
                                            getHandleProps={getHandleProps}
                                            values={values}
                                            index={index}
                                            vertical={verticalView}
                                            isEnergyReserveSelectd={currentProject?.isEnergyReserveSelectd}
                                          />
                                        )
                                        : (index === 0 || index === 4) ? (
                                          <KeyboardHandle
                                            key={handle.id}
                                            handle={handle}
                                            domain={domain}
                                            getHandleProps={function () { }}
                                            values={values}
                                            index={index}
                                            vertical={verticalView}
                                            isEnergyReserveSelectd={currentProject?.isEnergyReserveSelectd}
                                          />
                                        ) : (
                                          <KeyboardHandle
                                            key={handle.id}
                                            handle={handle}
                                            domain={domain}
                                            getHandleProps={getHandleProps}
                                            values={values}
                                            index={index}
                                            vertical={verticalView}
                                            isEnergyReserveSelectd={currentProject?.isEnergyReserveSelectd}
                                          />
                                        )
                                    )}
                                  </div>
                                )}
                              </Handles>

                              <Tracks left={false} right={false}>
                                {({ tracks, getTrackProps }) => (
                                  <div className="slider-tracks">
                                    {tracks.map(({ id, source, target }) => (
                                      <Track
                                        key={id}
                                        source={source}
                                        target={target}
                                        getTrackProps={function () { }}
                                        vertical={verticalView}
                                        isEnergyReserveSelectd={currentProject?.isEnergyReserveSelectd}
                                      />
                                    ))}
                                  </div>
                                )}
                              </Tracks>

                              <Ticks count={10}>
                                {({ ticks }) => (
                                  <div className="slider-ticks">
                                    {ticks.map((tick) => (
                                      <Tick
                                        key={tick.id}
                                        tick={tick}
                                        count={ticks.length}
                                      />
                                    ))}
                                  </div>
                                )}
                              </Ticks>
                            </Slider>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {false && (
                      <div className="row">
                        <div className="col-md-1 text-center pr-0 my-auto ">
                          <span className="se-legend-soc socMin"> </span>
                          &nbsp;
                          <span>
                            SoC Min<br></br>
                            {parseInt(
                              (parseInt(BESS.capacity) / 100) *
                              parseInt(BESS.soc_min)
                            )}{" "}
                            Kwh
                          </span>
                        </div>
                        <div className="col-md-3 text-center my-auto ">
                          <span className="se-legend-soc soc1"> </span>
                          &nbsp;
                          <span>
                            Essential load shedding threshold
                            <br></br>
                            {parseInt(
                              (parseInt(BESS.capacity) / 100) *
                              parseInt(BESS.soc_emergency)
                            )}{" "}
                            Kwh
                          </span>
                        </div>
                        <div className="col-md-3 text-center my-auto ">
                          <span className="se-legend-soc soc2"> </span>
                          &nbsp;
                          <span>
                            Non-essential load shedding threshold
                            <br></br>
                            {parseInt(
                              (parseInt(BESS.capacity) / 100) *
                              parseInt(BESS.soc_essential)
                            )}{" "}
                            Kwh
                          </span>
                        </div>
                        <div className="col-md-3 text-center my-auto ">
                          <span className="se-legend-soc soc3"> </span>
                          &nbsp;
                          <span>
                            Non-essential reconnection threshold
                            <br></br>
                            {parseInt(
                              (parseInt(BESS.capacity) / 100) *
                              parseInt(BESS.soc_nominal_power)
                            )}{" "}
                            Kwh
                          </span>
                        </div>
                        <div className="col-md-1 text-center p-0  my-auto ">
                          <span className="se-legend-soc socMax"> </span>
                          &nbsp;
                          <span>
                            SoC Max <br></br>
                            {parseInt(
                              (parseInt(BESS.capacity) / 100) *
                              parseInt(BESS.soc_max)
                            )}{" "}
                            Kwh
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="row pl-3 pr-3 mt-5">
                      <div className="table-responsive">
                        <table className="table table-load table-bordered w-100">
                          <thead>
                            <tr className="text-center">
                              <th colSpan="1" className="bess-load-table-th1">
                                Load
                              </th>
                              <th colSpan="2" className="bess-load-table-th1">
                                Load Shedding
                              </th>
                              <th colSpan="2" className="bess-load-table-th1">
                                Reconnection
                              </th>
                            </tr>
                            <tr className="text-center">
                              <th className="bess-load-table-th2"></th>
                              <th className="bess-load-table-th2">Rule</th>
                              <th className="bess-load-table-th2">
                                Threshold (kWh)
                              </th>
                              <th className="bess-load-table-th2">Rule</th>
                              <th className="bess-load-table-th2">
                                Threshold (kWh)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="text-center">
                              <td>Non Essential</td>
                              <td>{"SoC < SoC Non Essential Load Shedding"}</td>
                              <td className="bess-load-cell-non-essential">
                                {" "}
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_essential)
                                )}{" "}
                                kWh
                              </td>
                              <td>{"SoC > SoC Non Essential Load Reconnection"}</td>
                              <td>
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_nominal_power)
                                )}{" "}
                                kWh
                              </td>
                            </tr>

                            <tr className="text-center">
                              <td>Essential</td>
                              <td>{"SoC < SoC Essential Load Shedding"}</td>
                              <td className="bess-load-cell-essential">
                                {" "}
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_emergency)
                                )}{" "}
                                kWh
                              </td>
                              <td>{"SoC > SoC Non Essential Load Shedding"}</td>
                              <td className="bess-load-cell-soc-B">
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_essential)
                                )}{" "}
                                kWh
                              </td>
                            </tr>
                            <tr className="text-center">
                              <td>Emergency</td>
                              <td>{"SoC < SoC min Manufacturer"}</td>
                              <td className="bess-load-cell-soc-min">
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_min)
                                )}{" "}
                                kWh
                              </td>
                              <td>{"SoC > SoC Essential Load Shedding"}</td>
                              <td className="bess-load-cell-non-essential">
                                {" "}
                                {parseInt(
                                  (parseInt(BESS.capacity) / 100) *
                                  parseInt(BESS.soc_emergency)
                                )}{" "}
                                kWh
                              </td>
                            </tr>
                            <tr className="text-center">
                              <td>Grid Tied only</td>
                              <td>{"Utility Outage"}</td>
                              <td className="bess-outage">{""}</td>
                              <td>{"Utility restored"}</td>
                              <td className="bess-outage">{""}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label
                                htmlFor="inputEmail11"
                                className="col-sm-7 col-form-label"
                              >
                                BESS Power reserve in kW{" "}
                                <span className="se-mandatory">*</span>
                                <Tooltip
                                  position="right"
                                  iconColor="secondary"
                                  information="The power reserve is the percentage of DER power
                              that is kept as a reserve for site step loads.
                              When the real power reserve is smaller than this
                              power reserve, no more loads are reconnected."
                                />
                              </label>
                              <div className="col-sm-5">
                                <input
                                  type="text"
                                  autoComplete="none"
                                  className="form-control form-control-md"
                                  name="powerReserve"
                                  placeholder="BESS Power reserve in kw"
                                  maxLength="10"
                                  value={BESS.powerReserve}
                                  onChange={BessChangeHandler}
                                />

                                {BESS.powerReserve.toString() === "" ? (
                                  <div className="invalid-feedback-custom">
                                    BESS Power reserve in kw is required.
                                  </div>
                                ) : (parseFloat(BESS.powerReserve) /
                                  parseFloat(BESS.max_power)) *
                                  100 >
                                  50.0 ||
                                  (parseFloat(BESS.powerReserve) /
                                    parseFloat(BESS.max_power)) *
                                  100 <
                                  0 ? (
                                  <div className="invalid-feedback-custom">
                                    BESS Power reserve should not exceed more than
                                    50% Max Power(kW) .
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label
                                htmlFor="inputEmail11"
                                className="col-sm-7 col-form-label"
                              >
                                BESS Power reserve(% of max power)
                                <Tooltip
                                  position="right"
                                  iconColor="secondary"
                                  information="  The power reserve is the percentage of DER power
                              that is kept as a reserve for site step loads.
                              When the real power reserve is smaller than this
                              power reserve, no more loads are reconnected."
                                />
                              </label>
                              <div className="col-sm-5">
                                <input
                                  type="text"
                                  autoComplete="none"
                                  className="form-control form-control-md"
                                  name="powerReservePercentageBESS"
                                  placeholder="BESS Power reserve(% of max power)"
                                  maxLength="10"
                                  value={powerReservePercentageBESS}
                                  onChange={PowerChangeHandler}
                                />

                                {(parseFloat(BESS.powerReserve) /
                                  parseFloat(BESS.max_power)) *
                                  100 >
                                  50.0 ||
                                  (parseFloat(BESS.powerReserve) /
                                    parseFloat(BESS.max_power)) *
                                  100 <
                                  0 ? (
                                  <div className="invalid-feedback-custom">
                                    BESS Power reserve should not exceed more than
                                    50% Max Power(kW) .
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {gensetDetails.gensetAvailabilityStatus && showGenset() && (
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="row">
                      <div className="col-md-12">
                        <span className="se-font-14px-bold ">
                          Genset Load Management
                        </span>
                        <Tooltip
                          position="bottom"
                          iconColor="secondary"
                          information="Load shedding applies to genset power when it is the main anchor resource.
                     When the genset is overloaded, control system starts load shedding by priorities."
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label
                                htmlFor="inputEmail11"
                                className="col-sm-7 col-form-label"
                              >
                                <span className="line-height-25px">
                                  Genset Power reserve in kW{" "}
                                </span>
                                <span className="se-mandatory">*</span>
                                <Tooltip
                                  position="right"
                                  iconColor="secondary"
                                  information="The power reserve is the percentage of DER power
                              that is kept as a reserve for site step loads.
                              When the real power reserve is smaller than this
                              power reserve, no more loads are reconnected."
                                />
                              </label>
                              <div className="col-sm-5">
                                <input
                                  type="text"
                                  autoComplete="none"
                                  className="form-control form-control-md"
                                  name="powerReserve"
                                  placeholder="Genset Power reserve in kW"
                                  maxLength="10"
                                  value={genset.powerReserve}
                                  onChange={gensetChangeHandler}
                                />
                                {genset.powerReserve.toString() === "" ? (
                                  <div className="invalid-feedback-custom">
                                    Genset Power reserve in kW is required.
                                  </div>
                                ) : (parseFloat(genset.powerReserve) /
                                  parseFloat(genset.max_power)) *
                                  100 >
                                  50.0 ||
                                  (parseFloat(genset.powerReserve) /
                                    parseFloat(genset.max_power)) *
                                  100 <
                                  0 ? (
                                  <div className="invalid-feedback-custom">
                                    Genset Power reserve should not exceed more
                                    than 50% Max Power(kW) .
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label
                                htmlFor="inputEmail11"
                                className="col-sm-7 col-form-label"
                              >
                                <span className="line-height-25px">
                                  Genset Power reserve(% of max power)
                                </span>
                                <Tooltip
                                  position="right"
                                  iconColor="secondary"
                                  information="  The power reserve is the percentage of DER power
                                that is kept as a reserve for site step loads.
                                When the real power reserve is smaller than this
                                power reserve, no more loads are reconnected."
                                />
                              </label>
                              <div className="col-sm-5">
                                <input
                                  type="text"
                                  autoComplete="none"
                                  className="form-control form-control-md"
                                  name="powerReservePercentageGenset"
                                  placeholder="Genset Power reserve(% of max power)"
                                  maxLength="10"
                                  value={powerReservePercentageGenset}
                                  onChange={PowerChangeHandler}
                                />
                                {(parseFloat(genset.powerReserve) /
                                  parseFloat(genset.max_power)) *
                                  100 >
                                  50.0 ||
                                  (parseFloat(genset.powerReserve) /
                                    parseFloat(genset.max_power)) *
                                  100 <
                                  0 ? (
                                  <div className="invalid-feedback-custom">
                                    Genset Power reserve should not exceed more
                                    than 50% Max Power(kW) .
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ):     <div className="row">
                      <div className="col-md-12 mt-1 text-center mt-2 mb-2 bold">
                          No load shedding strategy is selected. Load shedding will not be
                     </div>
                     </div>
          }
      </>
    </ErrorBoundary>
  );
};

export default LoadShedding;
